import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Users } from "lucide-react";

export default function ProtectedRoute({ children, admin }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Users className="w-10 h-10 text-terracotta animate-pulse" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
